import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/ochrana-osobnich-udaju#cookies" as const,
	[Locale.en]: "/data-protection#cookies" as const,
} satisfies LocalizedString;

export function getCookiesPolicyPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
